import { Icon } from "@opendash/icons";
import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "..";
export const Container = styled.div `
  height: auto;
  min-height: 100%;
  width: 80%;

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;
`;
export const ContainerInner = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
`;
export const FrontPageHero = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;

  // box-shadow: inset 0px 0px 12px -2px rgba(0, 0, 0, 0.66);
  padding: 5px;
  // border-radius: 10px;
  margin-top: 1px;
`;
const SingleTileContainer = styled.div ``;
const SubTile = styled.div `
  width: 80px;
  height: 80px;
  margin: 5px 10px;
  background-color: ${(props) => props.color || "#676767"};
  color: #ffffff;
  z-index: 2;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;

  hyphens: auto;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: normal;

  :hover {
    background: white;
    color: ${(props) => props.color || "#676767"};
  }

  @media (min-width: 480px) {
    width: 110px;
    height: 110px;
  }
`;
const SubTileIconHolder = styled.div `
  margin-top: 5px;
  text-align: center;
  font-size: 20px;

  @media (min-width: 480px) {
    font-size: 30px;
  }
`;
const SubTileLabelnHolder = styled.div `
  text-align: center;
  font-size: 12px;
  padding: 5px;

  @media (max-width: 480px) {
    font-size: 10px;
  }
`;
export const Tile = styled.div `
  width: 150px;
  height: 150px;

  @media (min-width: 480px) {
    width: 200px;
    height: 200px;
  }

  margin: 10px;

  background: ${(props) => props.color || "#676767"};
  color: white;

  z-index: 2;

  border: 3px solid ${(props) => props.color || "#676767"};
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  :hover {
    background: white;
    color: ${(props) => props.color || "#676767"};
  }
`;
export const TileInner = styled.div ``;
export const LabelHolder = styled.div `
  text-align: center;
  font-size: 16px;
  padding: 10px;
`;
export const IconHolder = styled.div `
  text-align: center;
  font-size: 40px;

  @media (min-width: 480px) {
    font-size: 60px;
  }
`;
export const Element = ({ label, icon, color, onClick, children }) => {
    const t = useTranslation();
    return (React.createElement(SingleTileContainer, null,
        React.createElement(Tile, { color: color, onClick: onClick },
            React.createElement(TileInner, null,
                React.createElement(IconHolder, null,
                    React.createElement(Icon, { icon: icon })),
                React.createElement(LabelHolder, null, t(label))))));
};
export const HeroElement = ({ label, icon, color, onClick, children }) => {
    const t = useTranslation();
    return (React.createElement(SingleTileContainer, null,
        React.createElement(SubTile, { color: color, onClick: onClick },
            React.createElement(SubTileIconHolder, null,
                React.createElement(Icon, { icon: icon })),
            React.createElement(SubTileLabelnHolder, null, t(label)))));
};
//# sourceMappingURL=data:application/json;base64,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